import { render, staticRenderFns } from "./CompanyForm.vue?vue&type=template&id=517c3622&scoped=true"
import script from "./CompanyForm.vue?vue&type=script&lang=js"
export * from "./CompanyForm.vue?vue&type=script&lang=js"
import style0 from "./CompanyForm.vue?vue&type=style&index=0&id=517c3622&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "517c3622",
  null
  
)

export default component.exports